import script from "./CustomerOrderDetailsProductItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerOrderDetailsProductItem.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerOrderDetailsProductItem.vue?vue&type=style&index=0&id=7913a36a&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7913a36a"]])

export default __exports__